import { PieChart } from "chartist";
import { TariffRoute } from "./routes";
import Breadcrumbs from "./breadcrumbs";
import Micromodal from "../lib/micromodal";

export default class Tariff {
    constructor() {
        this.breadcrumbs = new Breadcrumbs('tariff');
        this.breadcrumbs.get();
        this.route = new TariffRoute();
        this.init();
    }

    init() {
        this.setDonuts();
        this.initListeners();
    }


    changeTvClasses() {
        document.querySelectorAll('.js-tv-card')?.forEach((tvCard) => {
            if (window.innerWidth < 768) {
                tvCard.classList.remove('tariff-card_position_tv', 'tariff-card_tv');
                tvCard.classList.add('tariff-card_position_horizontal', 'tariff-card_tv_mobile');
            } else {
                tvCard.classList.add('tariff-card_position_tv', 'tariff-card_tv');
                tvCard.classList.remove('tariff-card_position_horizontal', 'tariff-card_tv_mobile');
            }
        });
    }

    initListeners() {
        const t = setInterval(() => {
            if (document.readyState !== 'loading') {
                this.setDeviceList();
                this.changeTvClasses();
                this.initGuaranteedPayment();
                clearInterval(t);
            }
        }, 100);

        window.addEventListener('resize',() => {
            this.setDonuts()
            this.changeTvClasses()
        })

        // смена цены в зависимости от количества месяцев
        document.querySelectorAll('.js-change-month-count').forEach((el) => {
            el.addEventListener('click', (e) => {
                let month = e.target.dataset.month
                const prices = e.target.closest('.tariff-card')?.querySelectorAll('.js-contract-price .contract-price__item');
                prices?.forEach((price) => {
                    price.classList.remove('active');
                    if (price.classList.contains(`js-${month}`)) {
                        price.classList.add('active')
                    }
                })
            })
        })

        // формирование роута без перезагрузки страницы
        document.querySelectorAll('.tariff .nav-link').forEach((navlink) => {
            navlink.addEventListener('click', async (e) => {
                let name = e.target.innerText.trim();
                const urlParams = new URLSearchParams(window.location.search);

                let pathname = window.location.pathname.split('/');
                pathname = pathname.filter(v => v.length > 0)
                let city = pathname[0] || 'petrozavodsk';
                let main = pathname[1] || 'tariff';
                let primary = pathname[2] || '';

                // запись вторичного роута в случае, если вторичная вкладка выбрана
                let secondary = await this.route.tab(name);

                let queryString = urlParams.toString().length > 0 ? `?${urlParams.toString()}` : '';
                let refresh = window.location.origin + `/${city}/${main}/${primary}/${secondary}${queryString}/`;
                window.history.pushState({path: refresh}, '', refresh);

                document.querySelector('.js-breadcrumbs-item-last').textContent = this.breadcrumbs.get()[secondary] || '';
            })
        })

        // показать все пакеты программ
        document.querySelector('.js-show-more-channel')?.addEventListener('click', (e) => {
            document.querySelectorAll('.tariff .tv .tariff-card:not(.visible)')?.forEach((card) => {
                card.classList.add('is-visible');
            })
            e.target.style.display = 'none';
        })

        // список каналов
        document.querySelectorAll('.js-show-channel-list')?.forEach((el) => {
            el.addEventListener('click', (e) => {
                let channelList = e.target.closest('.tariff-card').querySelector('.channel-list');
                if (channelList) {
                    let modal = document.getElementById('tv-modal');
                    let modalBody = modal.querySelector('.modal__body');
                    while (modalBody.firstChild) {
                        modalBody.removeChild(modalBody.firstChild);
                    }
                    modalBody.append(channelList.cloneNode(true));

                    MicroModal.show('tv-modal', {
                        awaitOpenAnimation: true,
                        awaitCloseAnimation: true,
                        disableScroll: true,
                        disableFocus: true,
                    });
                }
            })
        })
    }

    setDeviceList() {
        const setDeviceList = (deviceList, speed) => {
            let count = '', logos = [];
            if (speed < 60) {
                count = 'Для 1 устройства';
                logos = ['notebook']
            } else if (speed < 100) {
                count = 'Для 1-3 устройств';
                logos = ['notebook', 'mobile', 'desktop'];
            } else if (speed < 300) {
                count = 'Для 3 устройств и более';
                logos = ['notebook', 'mobile', 'desktop', 'gamepad'];
            } else {
                count = 'Для 4 устройств'
                logos = ['notebook', 'mobile', 'desktop', 'gamepad'];
            }

            deviceList.querySelectorAll(`.js-get-device-count`)?.forEach((device) => {
                device.innerText = count;
            })

            logos.map((v) => {
                deviceList.querySelectorAll(`.${v}`)?.forEach((device) => {
                    device.classList.add('show')
                })
            })
        }

        document.querySelectorAll('.js-get-speed').forEach((el) => {
            let speed = el.innerText.trim();
            let deviceList = el.closest('.tariff-card').querySelector('.device-list');

            if (deviceList) {
                setDeviceList(deviceList, speed)
            }
        })
    }

    setDonuts() {
        let tariffWrappers = document.querySelectorAll('.js-get-tariff-card-wrapper')

        if (tariffWrappers.length === 0) {
            return;
        }

        let width = window.innerWidth > 767 ? '30px' : '16px';
        let donutWidth = window.innerWidth > 767 ? 5 : 3;

        tariffWrappers.forEach((v) => {
            let maxSpeed = 100;

            v.querySelectorAll('.js-get-speed')?.forEach((el) => {
                let speed = parseInt(el.innerText.trim());
                if (! isNaN(speed) && speed > maxSpeed) {
                    maxSpeed = speed;
                }
            })

            if (typeof maxSpeed !== 'undefined') {
                let speedDonuts = v.querySelectorAll('.speed-donut');
                let options = {
                    width: width,
                    height: width,
                    donut: true,
                    donutWidth: donutWidth,
                    showLabel: false,
                    chartPadding: 1,
                };

                if (speedDonuts.length > 0) {
                    speedDonuts.forEach((donut) => {
                        let speedWrapper = donut.parentElement;
                        let speed = speedWrapper.querySelector('.js-get-speed');
                        if (speed) {
                            new PieChart(donut, {
                                series: [speed.innerText.trim(), maxSpeed - speed.innerText.trim()]
                            }, options);
                        }
                    })
                }
            }
        })
    }

    initGuaranteedPayment() {
        document.querySelectorAll('.tariff .additional .col.name')?.forEach((el) => {
            if (el.innerText.includes('Гарантированный платеж')) {
                el.nextElementSibling.innerHTML += `<sup class="guaranteed-payment"></sup>`;
            }
        })
    }
}
